import React from 'react';
import PropTypes from 'prop-types';
import { CollectionStateProvider } from 'Context/CollectionStateContext';
import Container from './AuthenticationFactorList/Container';
import { AuthenticationFactorListProvider } from './AuthenticationFactorListContext';

const AuthenticationFactorList = ({
  authFactorsRelationship,
  hasUserSettingsRevampRelationship,
  ListProps,
}) => {
  return (
    <CollectionStateProvider
      args={{
        link: authFactorsRelationship.link('related'),
      }}
    >
      <AuthenticationFactorListProvider>
        <Container ListProps={ListProps} relationship={authFactorsRelationship} shouldUseUserSettingsRevamp={hasUserSettingsRevampRelationship} />
      </AuthenticationFactorListProvider>
    </CollectionStateProvider>
  );
};

AuthenticationFactorList.defaultProps = {
  ListProps: {},
  hasUserSettingsRevampRelationship: false,
};

AuthenticationFactorList.propTypes = {
  authFactorsRelationship: PropTypes.object.isRequired,
  ListProps: PropTypes.object,
  hasUserSettingsRevampRelationship: PropTypes.bool,
};

export default AuthenticationFactorList;
